<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-row >
          <b-col md="12" class="d-flex justify-content-end">
            <b-button variant="primary" @click="showAddTaxModal">
              <feather-icon icon="PlusIcon" class="mr-50" />
              New Tax
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12"  md="2" sm="2" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" />
            </b-form-group>
          </b-col>

        
          <b-col
            cols="12"
            class="d-flex justify-content-end mb-2"
            style="position: relative; z-index: 1"
          >
            <b-button variant="outline-danger" size="sm" @click="clearFilters">
              Clear Filters
            </b-button>
          </b-col>

          <b-col cols="12">
            <b-table
              striped
              hover
              responsive
              :items="paginatedFilteredTaxs"
              :fields="tax_fields"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
              <template #head(name)="scope">
                <div class="d-flex flex-column">
                  <span>{{ scope.label }}</span>
                  <b-form-input
                    v-model="filters.name"
                    placeholder="Search Tax Name"
                    size="sm"
                  />
                </div>
              </template>
              <template #head(taxAmount)="scope">
                <div class="d-flex flex-column">
                  <span>{{ scope.label }}</span>
                  <b-form-input
                    v-model="filters.taxAmount"
                    placeholder="Search Tax Rate"
                    size="sm"
                    type="number"
                  />
                </div>
              </template>
              <template #head(code)="scope">
                <div class="d-flex flex-column">
                  <span>{{ scope.label }}</span>
                  <b-form-input
                    v-model="filters.code"
                    placeholder="Search Code"
                    size="sm"
                  />
                </div>
              </template>
              <template #head(description)="scope">
                <div class="d-flex flex-column">
                  <span>{{ scope.label }}</span>
                  <b-form-input
                    v-model="filters.description"
                    placeholder="Search Description"
                    size="sm"
                  />
                </div>
              </template>

              <template #cell(actions)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  class="m-1"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item @click="showViewTaxModal(data.item)">
                    <feather-icon icon="EyeIcon" />
                    <span class="align-middle ml-1">View</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="showEditTaxModal(data.item)">
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-1">Edit</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="confirmDeleteTax(data.item.id)">
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-1">Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- <div class="d-flex justify-content-center mb-1">
              <div class="d-flex justify-content-center mb-1" v-if="loading">
                <b-spinner
                  variant="success"
                  label="Spinning"
                  style="width: 3rem; height: 3rem"
                ></b-spinner>
              </div>
            </div> -->
            <b-row>
              <b-form-group>
                Showing 
                {{ totalRows > 0 ? ((currentPage - 1) * perPage + 1) : 0 }} 
                to 
                {{
                  totalRows > 0
                    ? Math.min(currentPage * perPage, totalRows)
                    : 0
                }} 
                of 
                {{ totalRows }} 
                entries
              </b-form-group>
              
    </b-row>
          </b-col>

          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
          </b-col>
        </b-row>

        <!-- Modal for adding a new Tax -->
        <b-modal
          ref="modalAddTax"
          id="modal-add-tax"
          title="Add New Tax"
          @hide="resetForm"
          hide-footer
          centered
        >
          <validation-observer ref="addTaxForm" v-slot="{ invalid, validate }">
            <b-form
              @submit.prevent="
                validate().then((success) => success && addNewTax())
              "
            >
              <b-form-group label="Tax Name" label-for="taxName">
                <validation-provider
                  name="Tax Name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-input id="taxName" v-model="newTax.name" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Tax Rate" label-for="taxRate">
                <validation-provider
                  name="Tax Rate"
                  rules="required|numeric|min_value:0|max_value:100"
                  v-slot="{ errors }"
                >
                <b-form-input
                id="taxRate"
                type="number"
                step="0.01"
                v-model.number="newTax.taxAmount"
                @input="newTax.taxAmount = parseFloat(newTax.taxAmount)"
              />   
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Code" label-for="code">
                <validation-provider
                  name="Code"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-input id="code" v-model="newTax.code" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Description" label-for="description">
                <validation-provider
                  name="Description"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-input id="description" v-model="newTax.description" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label-for="isTDS">
                <b-form-checkbox id="isTDS" v-model="newTax.isTDS">
                  Is TDS?
                </b-form-checkbox>
              </b-form-group>
              <b-button type="submit" variant="primary" :disabled="invalid">
                Add Tax
              </b-button>
            </b-form>
          </validation-observer>
        </b-modal>

        <!-- Modal for editing a Tax -->
        <b-modal
          ref="modalEditTax"
          id="modal-edit-tax"
          title="Edit Tax"
          hide-footer
          centered
        >
          <validation-observer ref="editTaxForm" v-slot="{ invalid, validate }">
            <b-form
              @submit.prevent="
                validate().then((success) => success && updateTax())
              "
            >
              <b-form-group label="Tax Name" label-for="taxName">
                <validation-provider
                  name="Tax Name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-input id="taxName" v-model="editTax.name" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Tax Rate" label-for="taxRate">
                <validation-provider
                  name="Tax Rate"
                  rules="required|numeric|min_value:0|max_value:100"
                  v-slot="{ errors }"
                >
              <b-form-input
                id="taxRate"
                type="number"
                step="0.01"
                v-model.number="editTax.taxAmount"
                @input="newTax.taxAmount = parseFloat(editTax.taxAmount)"
              />   
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Code" label-for="code">
                <validation-provider
                  name="Code"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-input id="code" v-model="editTax.code" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Description" label-for="description">
                <validation-provider
                  name="Description"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-input
                    id="description"
                    v-model="editTax.description"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label-for="isTDS">
                <b-form-checkbox id="isTDS" v-model="editTax.isTDS">
                  Is TDS?
                </b-form-checkbox>
              </b-form-group>
              <b-button type="submit" variant="primary" :disabled="invalid">
                Save changes
              </b-button>
            </b-form>
          </validation-observer>
        </b-modal>

        <!-- Modal for viewing a Tax -->
        <b-modal
          ref="modalViewTax"
          id="modal-view-tax"
          title="View Tax"
          hide-footer
          centered
        >
          <b-form>
            <b-form-group label="Tax Name" label-for="viewTaxName">
              <b-form-input id="viewTaxName" v-model="viewTax.name" readonly />
            </b-form-group>
            <b-form-group label="Tax Rate" label-for="viewTaxRate">
              <b-form-input
                id="viewTaxRate"
                v-model="viewTax.taxAmount"
                readonly
              />
            </b-form-group>
            <b-form-group label="Code" label-for="viewTaxCode">
              <b-form-input id="viewTaxCode" v-model="viewTax.code" readonly />
            </b-form-group>
            <b-form-group label="Description" label-for="viewTaxDescription">
              <b-form-input
                id="viewTaxDescription"
                v-model="viewTax.description"
                readonly
              />
            </b-form-group>
            <b-form-group label-for="viewIsTDS">
              <b-form-checkbox
                id="isTDS"
                v-model="viewTax.isTDS"
                disabled
                readonly
              >
                Is TDS?
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-modal>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import {
  BTable,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BCardBody,
  BInputGroupAppend,
  BButton,
  BCard,
  BForm,
  BDropdown,
  BModal,
  BDropdownItem,
  BSpinner,
  BFormCheckbox,
} from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import {
  required,
  numeric,
  min_value,
  max_value,
} from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field is required",
});
extend("numeric", {
  validate(value) {
    return !isNaN(parseFloat(value));
  },
  message: "This field must be a valid number",
});
extend("min_value", {
  ...min_value,
  message: "The value must be at least {min}",
});
extend("max_value", {
  ...max_value,
  message: "The value must be {max} or less",
});

export default {
  components: {
    BCard,
    BTable,
    BModal,
    BForm,
    BRow,
    BCol,
    BCardBody,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownItem,
    ValidationObserver,
    ValidationProvider,
    BSpinner,
    BFormCheckbox,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 1,
      filter: null,
      filterOn: ["name", "taxAmount", "code", "description"],
      tax_fields: [
        { key: "name", label: "Tax Name", sortable: true },
        { key: "taxAmount", label: "Tax Rate", sortable: true },
        { key: "code", label: "Code", sortable: true },
        { key: "description", label: "Description", sortable: true },
        // { key: "isTDS", label: "Is TDS", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      filters: {
        name: "",
        taxAmount: "",
        code: "",
        description: "",
      },
      newTax: {
        name: null,
        taxAmount: null,
        code: null,
        description: null,
        isTDS: false,
      },
      editTax: {
        id: null,
        name: null,
        taxAmount: null,
        code: null,
        description: null,
        isTDS: false,
      },
      viewTax: {
        name: null,
        taxAmount: null,
        code: null,
        description: null,
        isTDS: false,
      },
    };
  },
  computed: {
    ...mapGetters("taxModule", {
      taxs: "taxs",
      loading: "loading",
    }),
    filteredTaxs() {
      return this.taxs.filter((tax) => {
        const matchesName =
          !this.filters.name ||
          tax.name.toLowerCase().includes(this.filters.name.toLowerCase());
        const matchesTaxAmount =
          !this.filters.taxAmount ||
          tax.taxAmount.toString().includes(this.filters.taxAmount.toString());
        const matchesCode =
          !this.filters.code ||
          tax.code.toLowerCase().includes(this.filters.code.toLowerCase());
        const matchesDescription =
          !this.filters.description ||
          tax.description
            .toLowerCase()
            .includes(this.filters.description.toLowerCase());
        return (
          matchesName && matchesTaxAmount && matchesCode && matchesDescription
        );
      });
    },
    paginatedFilteredTaxs() {
  const start = (this.currentPage - 1) * this.perPage;
  const end = start + this.perPage;
  return this.filteredTaxs.slice(start, end);
}
  },
  methods: {
    clearFilters() {
      this.filters = {
        name: "",
        taxAmount: "",
        code: "",
        description: "",
      };
    },
    ...mapActions("taxModule", [
      "getTaxListAction",
      "removeTaxAction",
      "addTaxAction",
      "updateTaxAction",
    ]),

    showAddTaxModal() {
      this.$refs.modalAddTax.show();
    },

    resetForm() {
      this.newTax = {
        name: null,
        taxAmount: null,
        code: null,
        description: null,
        isTDS: false,
      };
      this.editTax = {
        name: null,
        taxAmount: null,
        code: null,
        description: null,
        isTDS: false,
      };
      this.viewTax = {
        name: null,
        taxAmount: null,
        code: null,
        description: null,
        isTDS: false,
      };
    },

    async addNewTax() {
      const nameExists = this.taxs.some(
    (tax) => tax.name.trim().toLowerCase() === this.newTax.name.trim().toLowerCase()
  );
  if (nameExists) {
    await Swal.fire({
      title: "Duplicate Name",
      text: `A tax with the name "${this.newTax.name}" already exists.`,
      icon: "warning",
      confirmButtonText: "OK",
      customClass: {
        confirmButton: "btn btn-warning",
      },
      buttonsStyling: false,
    });
    return; // Stop further execution
  }
  
      this.loading = true;
      const loader = Swal.fire({
        title: "Processing...",
        text: "Please wait while the Tax is being added",
        allowOutsideClick: () => !Swal.isLoading(),
        showConfirmButton: false,
        showCancelButton: false,
        buttonsStyling: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await this.addTaxAction(this.newTax);
        loader.close();
        this.$bvModal.hide("modal-add-tax");
        await Swal.fire({
  title: "Success!",
  text: "Tax added successfully.",
  icon: "success",
  confirmButtonText: "OK",
  customClass: {
    confirmButton: "btn btn-primary",
  },
  buttonsStyling: false,
});
        this.loading = false;
        this.getTaxListAction();
        this.resetForm();
      } catch (error) {
        loader.close();
        this.error(error.response.data);
        this.loading = false;
        this.getTaxListAction();
      } finally {
        this.loading = false;
      }
    },

    showViewTaxModal(item) {
      this.viewTax = { ...item };
      this.$refs.modalViewTax.show();
    },
    showEditTaxModal(item) {
      this.editTax = { ...item };
      this.$refs.modalEditTax.show();
      this.getTaxListAction();
    },

    async updateTax() {
      this.loading = true;
      const loader = Swal.fire({
        title: "Processing...",
        text: "Please wait while the Tax is being updated",
        allowOutsideClick: () => !Swal.isLoading(),
        showConfirmButton: false,
        showCancelButton: false,
        buttonsStyling: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await this.updateTaxAction(this.editTax);
        loader.close();
        this.$bvModal.hide("modal-edit-tax");
        await Swal.fire({
  title: "Success!",
  text: "Tax updated successfully.",
  icon: "success",
  confirmButtonText: "OK",
  customClass: {
    confirmButton: "btn btn-primary",
  },
  buttonsStyling: false,
});

        this.loading = false;
        this.resetForm();
        this.getTaxListAction();
      } catch (error) {
        loader.close();
        this.error(error.response.data);
        this.loading = false;
        this.getTaxListAction();
      } finally {
        this.getTaxListAction();
        this.loading = false;
      }
    },
    async confirmDeleteTax(taxId) {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      });

      if (confirmation.isConfirmed) {
        this.deleteTax(taxId);
      } else if (confirmation.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "Your tax is safe :)",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    },

    async deleteTax(taxId) {
      const loader = Swal.fire({
        title: "Processing...",
        text: "Please wait while the Tax is being deleted",
        allowOutsideClick: () => !Swal.isLoading(),
        showConfirmButton: false,
        showCancelButton: false,
        buttonsStyling: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await this.removeTaxAction(taxId);
        loader.close();
        Swal.fire({
          title: "Deleted!",
          text: "The tax has been deleted.",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        this.resetForm();
        this.getTaxListAction();
      } catch (error) {
        loader.close();
        this.error(error.response.data);
        this.getTaxListAction();
      } finally {
        this.loading = false;
      }
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  async mounted() {
  const loader = Swal.fire({
    title: "Loading...",
    text: "Fetching tax list, please wait",
    allowOutsideClick: false,
    showConfirmButton: false,
    willOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    await this.getTaxListAction();
    this.totalRows = this.taxs.length;
  } catch (error) {
    this.error("Failed to load tax list.");
  } finally {
    loader.close();
  }
},
  watch: {
  filteredTaxs(newList) {
    this.totalRows = newList.length;

    const maxPage = Math.ceil(this.totalRows / this.perPage);
    if (this.currentPage > maxPage) {
      this.currentPage = maxPage || 1;
    }
  },
}
};
</script>

<style scoped>
/* Add your existing styles here */
</style>
